<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <h1 class="common_title">Settings</h1>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_12">
              <nav class="tabs">
                <ul>
                  <li href="#tab4" :class="{active : activeTab === 'chatSettings'}" @click="activeTab = 'chatSettings'"> Chat </li>
                </ul>
              </nav>
              <div class="tab_content_wrapper pl_0 pr_0 border_none">
                <div id="tab4" class="tab_content" :class="{show : activeTab === 'chatSettings'}">
                  <div class="fadein">
                    <div class="account_content">
                      <div class="row">
                        <div class="col_12">
                          <div :class="['form_row_inline', {'has_error': errorFor('greeting_message')}]">
                            <label class="required">Greeting message</label>
                            <div class="form_input">
                              <textarea type="text" rows="5" class="form_global" v-model="admin.greeting_message"></textarea>
                              <v-errors :errors="errorFor('greeting_message')"></v-errors>
                            </div>
                          </div>
                          <div :class="['form_row_inline', {'has_error': errorFor('max_file_size')}]">
                            <label class="required">Max File Size</label>
                            <div class="form_input">
                              <select class="form_global" v-model="admin.max_file_size">
                                <option value="">Select Once</option>
                                <option value="1024">1MB</option>
                                <option value="2048">2MB</option>
                                <option value="3072">3MB</option>
                                <option value="4096">4MB</option>
                                <option value="5120">5MB</option>
                                <option value="10240">10MB</option>
                                <option value="12288">12MB</option>
                                <option value="15360">15MB</option>
                              </select>
                              <v-errors :errors="errorFor('max_file_size')"></v-errors>
                            </div>
                          </div>
                          <div class="form_row_inline">
                            <label class=""></label>
                            <div class="form_input">
                              <button class="btn btn_primary" @click.prevent="updateChatSettings">Update</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
export default {
  name: 'chat-settings',
  components: {LoaderMaskComponent},
  data() {
    return {
      lyLoading: false,
      activeTab: 'chatSettings',
      admin: {
        greeting_message: '',
        max_file_size: '',
      },
    }
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.lyLoading = true;
      this.axios.get('/chat-settings')
      .then(({ data }) => {
        if(data.data){
          this.admin.greeting_message = data.data.greeting_message
          this.admin.max_file_size = data.data.max_file_size
        }
      }).finally(() => {
        this.lyLoading = false;
      })
    },
    updateChatSettings(){
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.post('/chat-settings', this.admin)
          .then(() => {
            this.showSuccessMsg("Updated Successfully!");
          })
          .catch((err) => {
              this.allErrors = err.response.data.errors
          })
          .finally(() => {
              this.lyLoading = false;
          })
    },
  }
}
</script>

<style scoped lang="scss">

</style>